/* tslint:disable */
/* eslint-disable */
/**
 * Marketplace Api
 * Marketplace Api description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: develop@taykus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Booking } from '../models';
// @ts-ignore
import { MatchExternalId } from '../models';
// @ts-ignore
import { MatchHash } from '../models';
// @ts-ignore
import { MatchRequest } from '../models';
// @ts-ignore
import { PreBooking } from '../models';
/**
 * MatchApi - axios parameter creator
 * @export
 */
export const MatchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a match
         * @param {MatchRequest} matchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMatch: async (matchRequest: MatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'matchRequest' is not null or undefined
            assertParamExists('createMatch', 'matchRequest', matchRequest)
            const localVarPath = `/api/match`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(matchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a match
         * @param {MatchRequest} matchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMatchWithoutSale: async (matchRequest: MatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'matchRequest' is not null or undefined
            assertParamExists('createMatchWithoutSale', 'matchRequest', matchRequest)
            const localVarPath = `/api/match/custom`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(matchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all matches alive
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllMatches: async (start: number, size: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'start' is not null or undefined
            assertParamExists('findAllMatches', 'start', start)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('findAllMatches', 'size', size)
            const localVarPath = `/api/match`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get hash for CRM generated match
         * @param {string} tenantId The tenant id
         * @param {number} id The crm id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMatchHash: async (tenantId: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('generateMatchHash', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generateMatchHash', 'id', id)
            const localVarPath = `/api/match/generate-hash`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get external id for match
         * @param {string} id The match id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalIdByHash: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getExternalIdByHash', 'id', id)
            const localVarPath = `/api/match/external-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MatchApi - functional programming interface
 * @export
 */
export const MatchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MatchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a match
         * @param {MatchRequest} matchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMatch(matchRequest: MatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMatch(matchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a match
         * @param {MatchRequest} matchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMatchWithoutSale(matchRequest: MatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMatchWithoutSale(matchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all matches alive
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllMatches(start: number, size: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Booking>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllMatches(start, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get hash for CRM generated match
         * @param {string} tenantId The tenant id
         * @param {number} id The crm id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateMatchHash(tenantId: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchHash>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateMatchHash(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get external id for match
         * @param {string} id The match id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalIdByHash(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchExternalId>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalIdByHash(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MatchApi - factory interface
 * @export
 */
export const MatchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MatchApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a match
         * @param {MatchRequest} matchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMatch(matchRequest: MatchRequest, options?: any): AxiosPromise<Booking> {
            return localVarFp.createMatch(matchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a match
         * @param {MatchRequest} matchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMatchWithoutSale(matchRequest: MatchRequest, options?: any): AxiosPromise<Booking> {
            return localVarFp.createMatchWithoutSale(matchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all matches alive
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllMatches(start: number, size: number, options?: any): AxiosPromise<Array<Booking>> {
            return localVarFp.findAllMatches(start, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get hash for CRM generated match
         * @param {string} tenantId The tenant id
         * @param {number} id The crm id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMatchHash(tenantId: string, id: number, options?: any): AxiosPromise<MatchHash> {
            return localVarFp.generateMatchHash(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get external id for match
         * @param {string} id The match id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalIdByHash(id: string, options?: any): AxiosPromise<MatchExternalId> {
            return localVarFp.getExternalIdByHash(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MatchApi - object-oriented interface
 * @export
 * @class MatchApi
 * @extends {BaseAPI}
 */
export class MatchApi extends BaseAPI {
    /**
     * 
     * @summary Create a match
     * @param {MatchRequest} matchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */
    public createMatch(matchRequest: MatchRequest, options?: AxiosRequestConfig) {
        return MatchApiFp(this.configuration).createMatch(matchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a match
     * @param {MatchRequest} matchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */
    public createMatchWithoutSale(matchRequest: MatchRequest, options?: AxiosRequestConfig) {
        return MatchApiFp(this.configuration).createMatchWithoutSale(matchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all matches alive
     * @param {number} start Zero-based page index
     * @param {number} size The page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */
    public findAllMatches(start: number, size: number, options?: AxiosRequestConfig) {
        return MatchApiFp(this.configuration).findAllMatches(start, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get hash for CRM generated match
     * @param {string} tenantId The tenant id
     * @param {number} id The crm id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */
    public generateMatchHash(tenantId: string, id: number, options?: AxiosRequestConfig) {
        return MatchApiFp(this.configuration).generateMatchHash(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get external id for match
     * @param {string} id The match id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchApi
     */
    public getExternalIdByHash(id: string, options?: AxiosRequestConfig) {
        return MatchApiFp(this.configuration).getExternalIdByHash(id, options).then((request) => request(this.axios, this.basePath));
    }
}
